export const Components = {
  Toast: {
    life_time: 5000,
  },
};
